import styled, { css, keyframes } from 'styled-components';

import { ViewModeQueries } from '@helpers/viewModeHelper';
import { FAVORITE_ONBOARD_KEY, SHOW_PATH, TRIGGER_PATH } from '@utils/onboarding';

const animationBounce = keyframes`
  0% { transform: translateY(50%); }
  25% { transform: translateY(-50%); }
  50% { transform: translateY(20%); }
  75% { transform: translateY(-20%); }
  100% { transform: translateY(0%); }
`;

const Container = styled.div<{ show: boolean }>`
  display: none;
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.gray4};
  align-items: center;
  justify-content: center;
  align-content: center;
  z-index: 101;
  animation: ${animationBounce} 0.3s ease-out forwards;

  ${ViewModeQueries.MD} {
    bottom: 20px;
    right: 20px;
  }

  &:hover {
    cursor: pointer;
  }

  &.${FAVORITE_ONBOARD_KEY}${TRIGGER_PATH}1${SHOW_PATH} {
    display: flex;
    background: white;
  }
  ${(props) =>
    props.show &&
    css`
      display: flex;
    `};
`;

export { Container };
